import { z } from "zod";
import type { ProviderGroupId } from "./provider-groups/provider-group-id";
import {
    isProviderGroupId,
    providerGroupIdZodSchema,
} from "./provider-groups/provider-group-id";
import type { ProviderId } from "./providers/provider-id";
import { isProviderId, providerIdZodSchema } from "./providers/provider-id";
import type { UserId } from "./users/user-id";
import { isUserId, userIdZodSchema } from "./users/user-id";

type OwnerId = ProviderId | UserId | ProviderGroupId | "alfred";

const ownerIdZodSchema = z.union([
    providerIdZodSchema,
    providerGroupIdZodSchema,
    userIdZodSchema,
    z.literal("alfred"),
]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOwnerId = (id: any): id is OwnerId => {
    return (
        isProviderId(id) ||
        isUserId(id) ||
        isProviderGroupId(id) ||
        id === "alfred"
    );
};

export { isOwnerId, ownerIdZodSchema };
export type { OwnerId };
